export function countIsTotalOnly(counts) {
    // The latter requirement should always be fulfilled, but putting it there because
    // it may be safer
    return Array.isArray(counts) && counts.length === 1 && counts[0] != null
}

export function convertFromCentsToCurrencyAmountString(cents) {
    let str = String(cents / 100).replace(".", ",")
    if (str.includes(",")) {
        const parts = str.split(",")
        if (parts[1].length === 1) {
            return parts[0] + "," + parts[1] + "0"
        }
    }
    return str
}

export function amountStringIsRounded(amountString, roundingIncrement) {
    // Convert amountString to cents (integer)
    if (typeof amountString !== "string" || !amountString.match(/^\d+(,[0-9]{0,2})?$/)) {
        return false
    }

    // Replace comma with dot for float conversion
    let floatAmount = parseFloat(amountString.replace(",", "."))
    if (isNaN(floatAmount)) {
        return false
    }
    // Convert to cents (integer)
    let amountCents = Math.round(floatAmount * 100)
    let rounding = parseInt(roundingIncrement, 10)
    if (isNaN(rounding) || rounding <= 0) {
        return false
    }
    // PHP logic: $reRoundedAmount = (int) (round($amount / $rounding) * $rounding);
    let reRoundedAmount = Math.round(amountCents / rounding) * rounding
    let difference = reRoundedAmount - amountCents
    return difference === 0
}
